import { displayToast } from "../../../helpers/notification";
import { OrderManagementTypes as Type } from "../../types/order";

export function getOrdersDetailRequest(id: any) {
  return {
    type: Type.GET_ORDERS_DETAIL_REQUEST,
    id
  };
}

export function getOrdersDetailRequestSuccess(data: any) {
  return {
    type: Type.GET_ORDERS_DETAIL_REQUEST_SUCCESS,
    payload: data,
  };
}

export function getOrdersDetailRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.GET_ORDERS_DETAIL_REQUEST_FAILURE,
    error: error,
  };
}